import axios from "axios";

export const ORGANIZATION_MEMBER_CONFIG = {
  admins: {
    retrieve: (orgId) => `/organizations/${orgId}/retrieve-admins/`,
    create: (orgId) => `/organizations/${orgId}/admins/`,
    remove: (orgId, joinId) => `/organizations/${orgId}/admins/${joinId}/`,
    titleKey: "organization_admin_plural",
    joinIdKey: "organization_user_admin_id",
  },
  managers: {
    retrieve: (orgId) => `/organizations/${orgId}/retrieve-managers/`,
    create: (orgId) => `/organizations/${orgId}/managers/`,
    remove: (orgId, joinId) => `/organizations/${orgId}/managers/${joinId}/`,
    titleKey: "manager_plural",
    joinIdKey: "organization_user_manager_id",
  },
  users: {
    retrieve: (orgId) => `/organizations/${orgId}/retrieve-users/`,
    activate: (orgId, joinId) =>
      `/organizations/${orgId}/users/${joinId}/activate/`,
    inactivate: (orgId, joinId) =>
      `/organizations/${orgId}/users/${joinId}/inactivate/`,
    titleKey: "user_plural",
    joinIdKey: "organization_user_id",
  },
};

export function membersQueryKey(organizationId, type) {
  return ["organization-members", organizationId, type];
}

/** Org user/admin/manager joins expose flat email/first_name/last_name (not nested user). */
export function orgJoinPersonFields(row) {
  if (!row) return { first_name: "", last_name: "", email: "" };
  return {
    first_name: row.user?.first_name || row.first_name || "",
    last_name: row.user?.last_name || row.last_name || "",
    email: row.user?.email || row.email || "",
  };
}

export function orgJoinDisplayName(row) {
  const { first_name, last_name } = orgJoinPersonFields(row);
  return `${first_name} ${last_name}`.trim();
}

export function orgJoinSelectLabel(row, fallbackId) {
  const { first_name, last_name, email } = orgJoinPersonFields(row);
  const name = `${first_name} ${last_name}`.trim();
  if (name && email) return `${name} (${email})`;
  return name || email || String(fallbackId || row?.user_id || "");
}

export function orgJoinId(row, type = "users") {
  if (!row) return null;
  const key = ORGANIZATION_MEMBER_CONFIG[type]?.joinIdKey;
  return (key && row[key]) || row.id || null;
}

export async function fetchMembers({
  organizationId,
  type,
  pageIndex,
  pageSize,
  searchValue,
  signal,
}) {
  const { data } = await axios.post(
    ORGANIZATION_MEMBER_CONFIG[type].retrieve(organizationId),
    {
      page: pageIndex,
      page_size: pageSize,
      search_value: searchValue || "",
    },
    { signal }
  );
  return data.response[0] || { data: [], page_count: 0, total: 0 };
}

export async function fetchOrgUsers(organizationId, signal) {
  const { data } = await axios.post(
    `/organizations/${organizationId}/retrieve-users/`,
    { page: 0, page_size: 200 },
    { signal }
  );
  return data.response[0]?.data || [];
}
